import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Talent() {
  return (
    <section
      className="hire-ios-app-developers-talent p-100"
      style={{ background: "#F9F9F9" }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="mt-auto mb-auto"
          >
            <div className="text-center">
              <h2>
                Our Team of Professional <span>React Developers</span>
              </h2>
            </div>
          </Col>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="">
            <div className="talent-tab position-relative"></div>
            <Swiper
              modules={[Navigation, Pagination, Autoplay]}
              loop={true}
              spaceBetween={25}
              slidesPerView={3}
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true,
              }}
              // navigation={{
              // prevEl: prevRef?.current,
              // nextEl: nextRef?.current,
              // }}
              onSwiper={() => console.log("slide change")}
              onSlideChange={() => console.log("slide change")}
              breakpoints={{
                320: {
                  slidesPerView: 1,
                },
                575: {
                  slidesPerView: 1.5,
                },
                666: {
                  slidesPerView: 1.8,
                },
                768: {
                  slidesPerView: 2,
                },
                1199: {
                  slidesPerView: 2,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 25,
                },
                1400: {
                  slidesPerView: 3,
                  spaceBetween: 30,
                },
                1600: {
                  slidesPerView: 3,
                  spaceBetween: 50,
                },
                1801: {
                  slidesPerView: 3,
                  spaceBetween: 100,
                },
              }}
              className="carosal_serv"
            >
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Emma_Johnson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Emma Johnson</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Emma is a talented front-end developer with a keen eye for
                      UI/UX design. She’s passionate about crafting responsive,
                      component-based UIs using ReactJS and has a strong command
                      of Redux, TypeScript, and GraphQL.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Alex_Kim.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Alex Kim</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Alex is a dedicated full-stack developer with a love for
                      building robust applications using ReactJS and Node.js.
                      He’s known for his expertise in server-side rendering and
                      seamless deployments on AWS.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Priya_Sharma.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Priya Sharma</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Priya is a creative developer who specializes in ReactJS
                      and mobile development with React Native. She’s
                      particularly skilled at managing complex app states and
                      optimizing performance.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Miguel_Santos.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Miguel Santos</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Miguel is an experienced developer with a strong focus on
                      enterprise-level ReactJS applications. He excels in
                      TypeScript and micro-frontend architecture, and he’s a pro
                      at containerization with Docker and Kubernetes.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>

              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Emma_Johnson.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Emma Johnson</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Emma is a talented front-end developer with a keen eye for
                      UI/UX design. She’s passionate about crafting responsive,
                      component-based UIs using ReactJS and has a strong command
                      of Redux, TypeScript, and GraphQL.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Alex_Kim.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Alex Kim</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Alex is a dedicated full-stack developer with a love for
                      building robust applications using ReactJS and Node.js.
                      He’s known for his expertise in server-side rendering and
                      seamless deployments on AWS.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Priya_Sharma.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Priya Sharma</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Priya is a creative developer who specializes in ReactJS
                      and mobile development with React Native. She’s
                      particularly skilled at managing complex app states and
                      optimizing performance.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
              <SwiperSlide>
                <div className="talent-card">
                  <div className="talent-info">
                    <div className="image">
                      <StaticImage
                        src="../../images/services-usa/hire_react/talent/Miguel_Santos.webp"
                        alt="tekrevol_web"
                        layout="constrained"
                        placeholder="blurred"
                        formats={["webp"]}
                        width={112}
                        height={112}
                      />
                    </div>
                    <div className="content">
                      <h3>Miguel Santos</h3>
                      <span>React Developer</span>
                      {/* <Link to="/" aria-label="John Smith" className="btn">
                        View Profile
                      </Link> */}
                    </div>
                  </div>
                  <div className="talent-skills">
                    <span>Javascript</span>
                    <span>HTML</span>
                    <span>CSS</span>
                  </div>
                  <div className="talent-content">
                    <p>
                      Miguel is an experienced developer with a strong focus on
                      enterprise-level ReactJS applications. He excels in
                      TypeScript and micro-frontend architecture, and he’s a pro
                      at containerization with Docker and Kubernetes.
                    </p>
                  </div>

                  <div class="btn-wrap">
                    <Link
                      to="/contact"
                      aria-label="Hire John Smith"
                      className="btn-pri"
                    >
                      Hire Now
                    </Link>
                  </div>
                </div>
              </SwiperSlide>
            </Swiper>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Talent;
